import React from 'react';
import {
    Card,
    renderRow,
    EmptySection,
    IEmptySectionProps,
} from 'components';
import { Color } from '_helpers';
import { IExpertCertificate } from 'components/models';
import { IApiError } from '_helpers/ApiConnector/types';
import emptyCertificateIcon from 'components/assets/svg/ac/empty_certificate_icon.svg';
import styles from './CertificateTab.module.scss';
import moment from 'moment';

const CertificateTab = ({
    certificateList,
    cardCategory,
    cardTitle,
    apiError,
    showLoader,
    renderHeaderButton,
    withoutPadding,
    cardClassName,
    cardContentClassName,
    ...placeholderProps
}: IProps) => {
    const renderCertificate = ({
        issueDate, expireDate, regNumber, fileUrl,
    }: IExpertCertificate, i: number) => {
        const date = `${issueDate.format('DD.MM.YYYY')} - ${expireDate.format('DD.MM.YYYY')}`;
        const status = moment(expireDate).isAfter(moment())
            ? <span style={{ color: `var(${Color.Success})` }}>Действует</span>
            : <span style={{ color: `var(${Color.Red})` }}>Не действует</span>;

        return (
            <section key={`certificate_${i}`} className={i !== 0 ? 'mt-5' : undefined}>
                {renderRow('НОМЕР', regNumber)}
                {renderRow('СРОК ДЕЙСТВИЯ', date)}
                {renderRow('СТАТУС', status)}

                <a className={styles.image} href={fileUrl} target="__blank">
                    <img src={`${fileUrl}/preview`} alt="certificateImage" />
                </a>
            </section>
        );
    };

    return (
        <Card
          title={cardTitle || 'Свидетельство члена комиссии'}
          category={cardCategory || 'Информация о свидетельстве члена комиссии'}
          apiError={apiError}
          showLoader={showLoader}
          headerChild={renderHeaderButton ? renderHeaderButton() : undefined}
          withoutPadding={withoutPadding}
          cardClassName={cardClassName}
          contentClassName={cardContentClassName}
          withoutBorder
        >
            {certificateList && certificateList.length ? (
                certificateList.map(renderCertificate)
            ) : (
                    <EmptySection
                      placeholderIcon={emptyCertificateIcon}
                      placeholderTitle={placeholderProps.placeholderTitle || 'Свидетельство не загружено'}
                      placeholderText={placeholderProps.placeholderText || 'Здесь будет отображаться свидетельство, выданное члену комиссии'}
                      {...placeholderProps}
                    />
                )}
        </Card>
    );
};

export default CertificateTab;

interface IProps extends Omit<IEmptySectionProps, 'placeholderTitle' | 'placeholderText'> {
    certificateList: IExpertCertificate[] | null;
    placeholderTitle?: string;
    placeholderText?: string;
    cardTitle?: string;
    cardCategory?: string;
    showLoader?: boolean;
    apiError?: IApiError | null;
    withoutPadding?: boolean;
    cardClassName?: string;
    cardContentClassName?: string;
    renderHeaderButton?: () => React.ReactNode;
}
